import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
  height: 100%;
`;
